<div [class.hidden-shared-block-controls]="isBlockHidden()" class="main-controls">
    <div
        class="btn-group"
        dropdown
        (onShown)="isShowDropDownMenu(true)"
        (onHidden)="isShowDropDownMenu(false)"
        container="body"
    >
        <button class="btn-control dropdown-toggle row-control" id="button-basic" dropdownToggle type="button">
            <span class="sp-icon icon-option-horizontal"> </span>
            <small>
                {{ "row" | translate }}
            </small>
        </button>
        <ul
            *dropdownMenu
            id="dropdown-basic"
            class="dropdown-menu dropdown-menu-left custom-left-position"
            role="menu"
            aria-labelledby="button-basic"
        >
            <li role="menuitem">
                <a class="dropdown-item" (click)="selectAction()">
                    <span class="sp-icon icon-pencil"> </span>
                    {{ "edit" | translate }}
                </a>
            </li>
            <li role="menuitem">
                <a class="dropdown-item" (click)="addSectionAction()">
                    <span class="sp-icon icon-plus-add"> </span>
                    {{ "add_row" | translate }}
                </a>
            </li>
            @if (!hideMoveUp()) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="moveUpAction()">
                        <span class="sp-icon icon-chevron-up"> </span>
                        {{ "move_up" | translate }}
                    </a>
                </li>
            }
            @if (!hideMoveDown()) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="moveDownAction()">
                        <span class="sp-icon icon-chevron-down"> </span>
                        {{ "move_down" | translate }}
                    </a>
                </li>
            }
            <li><hr /></li>
            <li role="menuitem" [tooltip]="disableDeleteEvent() ? disableDeleteEventTooltip() : ''">
                <a class="dropdown-item" [class.disabled]="disableDeleteEvent()" (click)="deleteAction()">
                    <span class="sp-icon icon-bin color-danger"> </span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
